const MEDIA_BREAKPOINTS = {
  breakpointSmallMobile: 430,
  breakpointMobile: 600,
  breakpointWideMobile: 768,
  breakpointTablet: 900,
};

export default MEDIA_BREAKPOINTS;
